<template lang="pug">
.gift-cards.profile-giftcards-container
  re-toast-alert(v-if="errorMessage" type="danger") {{ errorMessage }}
  ul.gift-cards__menu.menu
    li.menu__item
      a.menu__link(href="" @click.prevent="showAddGiftcardModal = true") Add a gift card
    li.menu__item
      router-link.menu__link(:to="{ name: 'racewaybooking.gift-card' }") Purchase a gift card
  template(v-if="areGiftcardsLoaded")
    .gift-cards__gifts
      template(v-if="pages")
        .gift-cards__card.gift-card(v-for="giftcard in giftcardsPage")
          .gift-card__container
            template(v-if="canShowBalance(giftcard)")
              p.gift-card__balance-caption Balance
              p.gift-card__money {{ giftcard.balance | currency }}
            p.gift-card__number-card.number-card {{ giftcard.number }}
            template(v-if="canShowRecipient(giftcard)")
              p.gift-card__email sent to: {{ giftcard.recipient.data.email }}
              p.gift-card__name {{ giftcard.recipient.data.first_name }} {{ giftcard.recipient.data.last_name }}
            template(v-if="canShowGiver(giftcard)")
              p.gift-card__email sent by: {{ giftcard.giver.data.email }}
              p.gift-card__name {{ giftcard.giver.data.first_name }} {{ giftcard.giver.data.last_name }}
            p.gift-card__email(v-if="isForMyself(giftcard)") purchased for myself
            .gift-card__align
              button.btn.btn-link.gift-card__forgot-code(v-if="isClaimable(giftcard)" @click="showClaimModal = true, claimGiftcard = giftcard") Claim
              v-button.btn.btn-link.gift-card__forgot-code(v-if="isCodeRecoverable(giftcard)" @click="sendCVV(giftcard)" :loading="isSendingCVV[giftcard.id]") Forgot Code?
              button.btn.btn-link.gift-card__forgot-code(v-if="isClaimableForMyself(giftcard)" @click="showClaimModal = true, claimGiftcard = giftcard") Claim for Myself
              p.gift-card__unclam-label(v-if="giftcard.state === 'given'") Unclaimed
              p.gift-card__clam-label(v-else) Claimed
          v-button.empty(v-if="isResendable(giftcard)" @click="resend(giftcard)" :loading="isResending[giftcard.id]")
            .gift-card__butt Resend gift card
          button.empty(v-if="isArchivable(giftcard)" @click="showArchiveModal = true, archiveGiftcard = giftcard")
            .gift-card__butt Archive
          .gift-card__butt.empty(v-if="!isResendable(giftcard) && !isArchivable(giftcard)")
      .gift-cards__card.gift-card_empty(v-else)
        p.gift-card_empty__text-empty No Gift Cards have been associated to this account. To add a Gift Cards click the button below.
    button.gift-cards__add-card.site_button.site_button_inverse(@click.prevent="showAddGiftcardModal = true") Add gift card
    .gift-cards__pagination.pagination(v-if="pages")
      pagination(:pages="pages" v-model="page" :cookie="PAGE_COOKIE")

  substrate(v-if="showAddGiftcardModal" @close="showAddGiftcardModal = false" inner-class="substrate__popup-change-pass-padd")
    p Enter the number and code of the Gift Card you would like to add.
    re-toast-alert(v-if="addingErrorMessage" type="danger") {{ addingErrorMessage }}
    form(@submit.prevent="")
      .substrate__popup-change-pass__gift_card
        label Gift Card Number
        input(v-model="number" type="number" placeholder="XXXX XXXX XXXX XXXX" autocomplete="off")
        a(href="" @click.prevent="$refs.whatIsNumberModal.show") What is this?
      .substrate__popup-change-pass__gift_code
        label Gift Card Code
        input(v-model="cvv" type="password" placeholder="****" autocomplete="off" maxlength="4")
        a(href="" @click.prevent="$refs.forgot.show") Forgot Code?
      div
        v-button.site_button(@click="add" :loading="isAdding" no-default-class) Add Card

  substrate(v-if="showGiftcardAddedModal" @close="showGiftcardAddedModal = false")
    p Your Gift Card has been added.
    div
      router-link(:to="{ name: 'racewaybooking.gift-card' }")
        button.site_button.substrate__popup-change-pass__purch-card.substrate__button__full-w Purchase a gift card
      button.site_button.site_button_inverse.substrate__popup-change-pass__more-gift.substrate__button__full-w(@click.prevent="showAddGiftcardModal = !(showGiftcardAddedModal = false)") Add one more Gift Card

  what-is-giftcard-number-modal(ref="whatIsNumberModal")

  substrate(v-if="showArchiveModal" @close="showArchiveModal = false")
    p Do you want to archive your Gift Card?
    re-toast-alert(v-if="archivingErrorMessage" type="danger") {{ archivingErrorMessage }}
    .substrate__popup-change-pass--archive
      v-button.site_button.site_button_inverse.substrate__popup-change-pass__more-gift(@click="archive" :loading="isArchiving" no-default-class) Yes
      button.site_button.substrate__popup-change-pass__purch-card(@click.prevent="showArchiveModal = false") No

  substrate(v-if="showArchivedModal" @close="showArchivedModal = false")
    p Your Gift Card has been archived.
    div
      router-link(:to="{ name: 'racewaybooking.gift-card' }")
        button.site_button.substrate__popup-change-pass__purch-card.substrate__button__full-w Purchase a gift card

  substrate(v-if="showGiftcardResentModal" @close="showGiftcardResentModal = false")
    p The gift card has been resent to {{ resentEmail }}.

  substrate(v-if="showClaimModal" @close="showClaimModal = false")
    p Would you like to claim this Gift Card for yourself?
    re-toast-alert(v-if="claimErrorMessage" type="danger") {{ claimErrorMessage }}
    .substrate__popup-change-pass--archive
      v-button.site_button.site_button_inverse.substrate__popup-change-pass__more-gift(@click="claim" :loading="isClaiming" no-default-class) Yes
      button.site_button.substrate__popup-change-pass__purch-card(@click.prevent="showClaimModal = false") No

  substrate(v-if="showClaimedModal" @close="showClaimedModal = false")
    p Your Gift Card has been claimed.

  re-giftcard-forgot(ref="forgot")

</template>

<script>
import axios from 'axios'
import { mapGetters } from 'vuex'
import { required } from 'vuelidate/lib/validators'
import Cookies from 'js-cookie'

import { getFirstErrorMessage } from '~/lib/axios'

import ConfigMixin from '../../components/_mixins/config'
import PagesMixin from '../../components/_mixins/pages'
import GiftcardMixins from '../../components/_mixins/giftcard'

import Pagination from './pagination'

const PER_PAGE = 3
const PAGE_COOKIE = 'profile-giftcards-page'

export default {
  settings: 'page.profile.tab.giftcards',
  translations: 'page.profile.tab.giftcards',
  mixins: [
    ConfigMixin,
    PagesMixin,
    GiftcardMixins,
  ],

  components: {
    Pagination,
  },

  data: () => ({
    PAGE_COOKIE,

    areGiftcardsLoaded: false,
    giftcards: [],
    page: 1,
    pages: 0,

    isResending: {},
    isSendingCVV: {},
    isClaiming: false,
    isAdding: false,
    isArchiving: false,
    isRecovering: false,

    errorMessage: null,
    addingErrorMessage: null,
    archivingErrorMessage: null,
    claimErrorMessage: null,

    number: null,
    cvv: null,
    archiveGiftcard: null,
    claimGiftcard: null,
    resentEmail: null,

    showAddGiftcardModal: false,
    recoveringErrorMessage: null,
    showGiftcardAddedModal: false,
    showArchiveModal: false,
    showArchivedModal: false,
    showGiftcardResentModal: false,
    showClaimModal: false,
    showClaimedModal: false,
  }),

  validations: {
    number: {
      required,
    },
    cvv: {
      required,
    },
    addingGroup: [
      'number', 'cvv'
    ],
  },

  computed: {
    ...mapGetters({
      user: 'authUser',
    }),

    giftcardsPage() {
      return this.giftcards.slice((this.page - 1) * PER_PAGE, this.page * PER_PAGE)
    }
  },

  async created() {
    this.page = Number(Cookies.get(PAGE_COOKIE) || 1),
    await this.load()
  },

  methods: {
    async load() {
      const { data: { data: giftcards } } = await axios.get(`${this.config.apiUri}/customer/giftcard?page_size=999`)
      this.giftcards = giftcards

      this.pages = Math.ceil(this.giftcards.length / PER_PAGE)
      if (this.page > this.pages) {
        this.page = this.pages
      }

      this.areGiftcardsLoaded = true
    },

    async claim() {
      try {
        this.isClaiming = true
        await axios.post(`${this.config.apiUri}/customer/giftcard/${this.claimGiftcard.id}/claim`)
        this.showClaimedModal = true
        this.showClaimModal = false
        this.claimErrorMessage = null
        await this.load()
      } catch (e) {
        this.claimErrorMessage = getFirstErrorMessage(e)
      } finally {
        this.isClaiming = false
      }
    },

    async resend(giftcard) {
      try {
        this.$set(this.isResending, giftcard.id, true)
        await axios.post(`${this.config.apiUri}/customer/giftcard/${giftcard.id}/resend`)
        this.resentEmail = giftcard.recipient.data.email
        this.showGiftcardResentModal = true
      } catch (e) {
        this.errorMessage = getFirstErrorMessage(e)
      } finally {
        this.$set(this.isResending, giftcard.id, false)
      }
    },

    async sendCVV(giftcard) {
      this.$set(this.isSendingCVV, giftcard.id, true)
      await this.$refs.forgot.forgot(giftcard)
      this.errorMessage = this.$refs.forgot.errorMessage
      this.$set(this.isSendingCVV, giftcard.id, false)
    },

    async add() {
      try {
        const payload = {
          number: this.number,
          cvv: this.cvv,
        }
        this.isAdding = true
        await axios.post(`${this.config.apiUri}/customer/giftcard/add`, payload)
        await this.load()
        this.showAddGiftcardModal = false
        this.showGiftcardAddedModal = true
        this.addingErrorMessage = null
      } catch (e) {
        this.addingErrorMessage = getFirstErrorMessage(e)
      } finally {
        this.isAdding = false
      }
    },

    async archive() {
      try {
        this.isArchiving = true
        await axios.post(`${this.config.apiUri}/customer/giftcard/${this.archiveGiftcard.id}/archive`)
        await this.load()
        this.archivingErrorMessage = null
        this.showArchiveModal = false
        this.showArchivedModal = true
      } catch (e) {
        this.archivingErrorMessage = getFirstErrorMessage(e)
      } finally {
        this.isArchiving = false
      }
    },
  },
}
</script>

<style lang="scss">
.page-body-content.page-general-body-content {
  // max-width: unset;
  .my-account-navigation {
    margin: auto;
  }
}

.gift-cards.profile-giftcards-container {
  display: block;

  button.btn.btn-link {
    padding: 0;
    border: 0;
    height: fit-content;
  }

  .gift-card__container {
    padding-top: 34px;
    .gift-card__balance-caption {
      margin-top: -10px;
    }
  }

  .gift-card__butt.empty:after {
    background-image: none;
  }

  button.empty {
    padding: 0;
    border: 0;
    border-radius: 0;
    background-color: unset;
  }

  .gift-card__number-card {
    padding-top: 0;
    padding-bottom: 0;
    position: absolute;
    right: 20px;
    top: 24px;
  }

  .gift-card__align {
    position: absolute;
    bottom: 0px;
    left: 24px;
    right: 24px;
  }

  .substrate__popup-change-pass input {
    border: 1px solid #BEBEBE;
  }
}

@media screen and (max-width: 375px) {
  .gift-card__clam-label,
  .gift-card__unclam-label {
    margin-bottom: 1rem;
  }

  .gift-card__container:before,
  .play-card__container:before {
    background-size: 100% 100%;
  }
  .gift-card__container,
  .gift-card_empty,
  .play-card_empty,
  .play-card__container {
    height: 160px;
  }
}
</style>
